export let routes = [
  {
    path: '/x3-side-absent-log',
    name: 'x3-side-absent-log',
    component: () => import('@x3/js/side/absent/absent-log.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsAbsentLog(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-absent-log',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
